module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_HOME.b6b9d385.svg";